import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CatogeriesList from "./Catogeries";
import Searchimg from "../../images/EXPLORE DIVISIONS/explore-image-other.jpg";
import PDFData from "./Pdfdata";
import sealents from "../Data/SEALENTS.json"


const StructuralFramework = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  // const [loading, setLoading] = useState(true);


 useEffect(() => {
  const preferredOrder = [
    "SilGlaze N10",
    "Silpruf",
    "pensil",
    "SSG 4000",
    "SSG4800J",
    "Silglaze",
    "IGS3723",
    "IGS 3760",
   "SSG4400 Sealant",
    "ULTRAGLAZE",
    "ultraglaze",
    "FENZI",
    "SS Construction Primers"
  ];

  const normalize = (str) =>
    typeof str === "string"
      ? str.toLowerCase().replace(/\s+/g, "").replace(/™/g, "")
      : "";

  const fetchProducts = async () => {
    try {
      const response = await fetch("https://backend.aktcorp.com/product");
      const apiProducts = await response.json();
      const fetchedArray = apiProducts.data || [];

      const filteredStatic = sealents.filter(
        (item) => item.category === "AKT TRADING" && item.subcategory === "SEALENTS"
      );

      const filteredFetched = fetchedArray.filter(
        (item) => item.category === "AKT TRADING" && item.subcategory === "SEALENTS"
      );

      const combinedData = [...filteredStatic, ...filteredFetched];

      const ordered = combinedData.sort((a, b) => {
        const aTitle = Array.isArray(a.title) ? a.title.join(" ") : a.title || "";
        const bTitle = Array.isArray(b.title) ? b.title.join(" ") : b.title || "";

        const aNorm = normalize(aTitle);
        const bNorm = normalize(bTitle);

        const aIndex = preferredOrder.findIndex((pref) => aNorm.includes(normalize(pref)));
        const bIndex = preferredOrder.findIndex((pref) => bNorm.includes(normalize(pref)));

        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        return 0;
      });

      setProducts(ordered);
    } catch (error) {
      console.error("Error fetching API products:", error);

      const fallbackData = sealents.filter(
        (item) => item.category === "AKT TRADING" && item.subcategory === "SEALENTS"
      );

      const orderedFallback = fallbackData.sort((a, b) => {
        const aTitle = Array.isArray(a.title) ? a.title.join(" ") : a.title || "";
        const bTitle = Array.isArray(b.title) ? b.title.join(" ") : b.title || "";

        const aNorm = normalize(aTitle);
        const bNorm = normalize(bTitle);

        const aIndex = preferredOrder.findIndex((pref) => aNorm.includes(normalize(pref)));
        const bIndex = preferredOrder.findIndex((pref) => bNorm.includes(normalize(pref)));

        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        return 0;
      });

      setProducts(orderedFallback);
    }
  };

  fetchProducts();
}, []);


  //     return (
  //       <div>
  //         {products.map((product, index) => (
  //           <div key={product.productId}>
  //             <h3>{product.title?.[0]}</h3>
  //             <img src={product.imageUrl} alt={product.title?.[0]} width={100} />
  //           </div>
  //         ))}
  //       </div>
  //     );
  //   };



  const handleNavigate = (product) => {
    if (!product?.title?.[0]) {
      console.error("Product title is missing or invalid:", product);
      return;
    }

    const productTitleSlug = product.title[0].replace(/\s+/g, '-').toLowerCase();
    navigate(`/product/${productTitleSlug}`, { state: { product } });
  };

  return (
    <div className="flex flex-col md:flex-row bg-[#0c2341] text-white min-h-screen">
      <aside className="w-full md:w-1/4 rounded-lg p-0 md:p-6">
        <div className="border-t-2 border-gray-300 mt-6 p-4 flex flex-col bg-white rounded-lg">
          <CatogeriesList />
        </div>
        <div className="border-t-2 border-gray-300 mt-6 p-4 flex flex-col bg-white rounded-lg md:mb-4">
          <h2 className="text-2xl font-bold mb-2 text-black text-center">
            CONSULT OUR EXPERTS
          </h2>
          <p className="text-gray-800 text-sm mb-4">
            Regardless of your industry, we’ll deliver solutions and recommend the products you need to succeed.
          </p>
          <Link to="/contact-us">
            <button className="px-6 w-full py-2 border-2 border-[#0C2340] text-[#0C2340] hover:bg-[#1B365D] hover:text-white font-semibold rounded-lg transition duration-300">
              ASK OUR EXPERT
            </button>
          </Link>
          <img src={Searchimg} alt="Product Search" className="mt-4 w-full md:w-full md:min-h-[500px] h-auto" />
        </div>
        <div>
          <PDFData />
        </div>
      </aside>

      <main className="flex-1 p-0 sm:p-4 md:!p-6 lg:!p-8 xl:!p-10 py-2">
        <h1 className="text-base md:text-2xl md:mb-10 py-2">
          <Link to="/">Home</Link>   / AKT TRADING / <span className="font-bold"> SEALENTS DIVISION</span>
        </h1>
        <h1 className="text-2xl md:text-4xl font-bold">Sealents Solutions</h1>

        {/* Render Filtered Data */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6 w-full">
          {products.length > 0 ? (
            products.map((product, index) => (
              <div
                key={`${product.productId || product.title?.[0] || 'product'}-${index}`}
                onClick={() => handleNavigate(product)}
                className="bg-[#3a506f] hover:bg-[#f3f4f6] hover:text-gray-900 p-3 rounded-lg cursor-pointer flex flex-col w-full transition-all duration-300"
              >
                {/* Image with loading spinner */}
                <div className="w-full h-60 bg-[#f3f4f6] rounded relative overflow-hidden flex items-center justify-center">
                  <img
                    src={`${product.imageUrl}?t=${new Date().getTime()}`}
                    alt={product.title?.[0]}
                    className="w-full h-60 object-contain absolute top-0 left-0 transition-opacity duration-500"
                    onLoad={(e) => {
                      e.target.style.opacity = '1';
                      const next = e.target.nextElementSibling;
                      if (next) next.style.display = 'none'; // hide spinner
                    }}
                    style={{ opacity: 0 }}
                  />
                  <div className="spinner absolute"></div>
                </div>

                {/* Spinner Styles */}
                <style>
                  {`
            .spinner {
              border: 2px solid #e5e7eb; 
              border-top: 2px solid #0c2341; 
              border-radius: 50%;
              width: 40px;
              height: 40px;
              animation: spin 1s linear infinite;
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
                </style>

                {/* Title */}
                <h3 className="font-bold mt-2 text-2xl py-2 line-clamp-1">{product.title?.[0]}</h3>

                {/* Description */}
                <div
                  className="text-base overflow-hidden line-clamp-5"
                  dangerouslySetInnerHTML={{ __html: product.descriptions?.[0] }}
                ></div>

                {/* Read More */}
                <button
                  onClick={() => handleNavigate(product)}
                  className="px-3 py-2 w-full mt-3 bg-white border-2 border-[#0C2340] text-[#0C2340] 
            hover:!bg-[#0c2341] hover:text-white font-semibold rounded-lg transition duration-300"
                >
                  Read More
                </button>
              </div>
            ))
          ) : (
            <p className="text-center text-lg col-span-3 mt-10">Please Wait . . .</p>
          )}
        </div>

      </main>
    </div>
  );
};

export default StructuralFramework;
